import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import Navbar from '../components/navbar'
import Footer from '../components/footer'
import ContactModal from '../components/contact-modal'
import './about-us.css'

const AboutUs = (props) => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false)
  const [buttonSource, setButtonSource] = useState('')

  const openContactModal = (source = 'Unbekannt') => {
    setButtonSource(source)
    setIsContactModalOpen(true)
  }

  const closeContactModal = () => {
    setIsContactModalOpen(false)
  }

  return (
    <div className="about-us-container">
      <Helmet>
        <title>Über uns | Social Recruiting Agentur Berlin</title>
        <meta name="description" content="Lernen Sie unser Team kennen - Ihre Experten für Social Media Recruiting in Berlin. Seit 2009 helfen wir Unternehmen bei der digitalen Mitarbeitergewinnung." />
        <meta property="og:title" content="Über uns | Social Recruiting Agentur Berlin" />
      </Helmet>
      
      <Navbar rootClassName="navbarroot-class-name" onContactClick={openContactModal}></Navbar>
      
      <section className="about-hero-section">
        <div className="about-hero">
          <div className="about-hero-content">
            <header className="about-hero-header" >
              <h1 className="about-heading">
                Wir leben Social Recruiting!
              </h1>
              <p className="about-subtitle">
                Ihre Experten für digitale Mitarbeitergewinnung aus Berlin
              </p>
            </header>
          </div>
        </div>
      </section>

      <section className="about-mission-section">
        <div className="about-content-wrapper">
          <div className="about-mission-content">
            <span className="section-head">Unsere Mission</span>
            <h2 className="section-heading">
              Gemeinsam gegen den Fachkräftemangel
            </h2>
            <p className="section-description">
              Unsere Social Recruiting Agentur steht für innovative, wirkungsvolle digitale Recruiting-Strategien und starke Partnerschaften. Seit 2009 bauen wir auf unserer weitreichenden Erfahrung im Social Media Marketing auf und haben uns auf die erfolgreiche Mitarbeitergewinnung über soziale Netzwerke spezialisiert. 
            </p>
            <p className="section-description">
              Unser Ansatz basiert auf der perfekten Kombination aus datengetriebenen Analysen und kreativen Employer-Branding-Kampagnen. Jeden Tag nehmen wir die Herausforderung an, gemeinsam mit unseren Kunden den perfekten Match zwischen Unternehmen und Kandidaten zu finden. Unser Ziel: Ihre offenen Stellen mit den besten Talenten zu besetzen – effizient, zielgerichtet und nachhaltig.
            </p>
            <p className="section-description">
              Unser Team aus sorgfältig ausgewählten Recruiting- und Social-Media-Experten arbeitet mit unermüdlichem Einsatz und grenzenloser Begeisterung an Ihren Recruiting-Projekten. Wir sind Ihr vertrauensvoller Partner für erfolgreiche Social Media Recruiting Lösungen. Unsere Mission ist es, Ihren Recruiting-Erfolg nachhaltig zu steigern und Sie als attraktiven Arbeitgeber zu positionieren.
            </p>
            <p className="section-description">
              Vertrauen Sie auf eine Partnerschaft mit uns – einer Agentur, die nicht nur in der Praxis bewährt ist, sondern auch stets mit Leidenschaft und Präzision Ihre Recruiting-Projekte zum Erfolg führt. Mit uns investieren Sie in nachhaltige und effektive Social Recruiting Strategien, die auf realen Ergebnissen und nachweislichen Erfolgen basieren.
            </p>
          </div>
          <div className="about-stats">
            <div className="stat-card">
              <h3 className="stat-number">2009</h3>
              <span className="stat-label">gegründet</span>
            </div>
            <div className="stat-card">
              <h3 className="stat-number">20+</h3>
              <span className="stat-label">Mitarbeiter:innen</span>
            </div>
            <div className="stat-card">
              <h3 className="stat-number">500+</h3>
              <span className="stat-label">erfolgreiche Kampagnen</span>
            </div>
            <div className="stat-card">
              <h3 className="stat-number">Berlin</h3>
              <span className="stat-label">Headquarter</span>
            </div>
          </div>
        </div>
      </section>

      <section className="about-values-section">
        <header className="about-section-header">
          <span className="section-head">Unsere Werte</span>
          <h2 className="section-heading">Was uns antreibt</h2>
        </header>
        <div className="values-grid">
          <div className="value-card">
            <div className="value-icon">🎯</div>
            <h3 className="value-title">Zielgenau</h3>
            <p className="value-description">
              Wir finden die perfekten Kandidaten für Ihre offenen Stellen – präzise und effizient.
            </p>
          </div>
          <div className="value-card">
            <div className="value-icon">🚀</div>
            <h3 className="value-title">Innovativ</h3>
            <p className="value-description">
              Modernste Recruiting-Technologien und kreative Ansätze für maximalen Erfolg.
            </p>
          </div>
          <div className="value-card">
            <div className="value-icon">🤝</div>
            <h3 className="value-title">Partnerschaftlich</h3>
            <p className="value-description">
              Ihr Erfolg ist unser Erfolg – wir arbeiten Hand in Hand mit Ihnen.
            </p>
          </div>
          <div className="value-card">
            <div className="value-icon">📊</div>
            <h3 className="value-title">Datengetrieben</h3>
            <p className="value-description">
              Entscheidungen basierend auf Fakten und messbaren Ergebnissen.
            </p>
          </div>
        </div>
      </section>

      <section className="about-team-section">
        <header className="about-section-header">
          <span className="section-head">Unser Team</span>
          <h2 className="section-heading">Die Menschen hinter Ihrem Recruiting-Erfolg</h2>
          <p className="section-description">
            Lernen Sie die Experten kennen, die täglich daran arbeiten, die besten Talente für Ihr Unternehmen zu gewinnen.
          </p>
        </header>
        <div className="team-grid">
          <div className="team-member">
            <div className="member-image-container">
              <img src="/toibas-ceo-team.png" alt="Tobias" className="member-image" />
              <div className="member-overlay">
                <a href="https://www.linkedin.com/in/tobias-s-32bab365/" target="_blank" rel="noopener noreferrer" className="linkedin-link">
                  <img src="/Icons/linkedin-200h.png" alt="LinkedIn" className="linkedin-icon" />
                </a>
              </div>
            </div>
            <h4 className="member-name">Tobias</h4>
            <p className="member-role">CEO / Co-Founder</p>
            <p className="member-description">
              Als Gründer und Geschäftsführer bringt Tobias über 15 Jahre Erfahrung im Digital Marketing mit. Seine Vision: Social Recruiting für jedes Unternehmen zugänglich und erfolgreich zu machen.
            </p>
          </div>

          <div className="team-member">
            <div className="member-image-container">
              <img src="/team-gorden.png" alt="Gorden" className="member-image" />
            </div>
            <h4 className="member-name">Gorden</h4>
            <p className="member-role">Co-Founder</p>
            <p className="member-description">
              Als wandelndes Recruiting-Lexikon hat Gorden auf jede Frage die passende Antwort und entwickelt innovative Strategien für unsere Kunden.
            </p>
          </div>

          <div className="team-member">
            <div className="member-image-container">
              <img src="/team-robert.png" alt="Robert" className="member-image" />
            </div>
            <h4 className="member-name">Robert</h4>
            <p className="member-role">Teamleader Social Recruiting</p>
            <p className="member-description">
              Robert ist unser Experte für komplexe Recruiting-Kampagnen und sorgt als Teamleiter dafür, dass jedes Projekt zum Erfolg wird.
            </p>
          </div>

          <div className="team-member">
            <div className="member-image-container">
              <img src="/patrick-b-team.webp" alt="Patrick B" className="member-image" />
            </div>
            <h4 className="member-name">Patrick B</h4>
            <p className="member-role">Senior Social Media Manager</p>
            <p className="member-description">
              Patrick ist unser LinkedIn-Experte und weiß genau, wie man Fach- und Führungskräfte über professionelle Netzwerke erreicht.
            </p>
          </div>
        </div>
      </section>

      <section className="about-cta-section">
        <div className="about-cta-content">
          <h2 className="cta-heading">
            Bereit, gemeinsam die besten Talente zu finden?
          </h2>
          <p className="cta-description">
            Lassen Sie uns über Ihre Recruiting-Herausforderungen sprechen und gemeinsam Lösungen entwickeln.
          </p>
          <div className="cta-button" onClick={() => openContactModal('Über uns - Kontakt aufnehmen')} style={{ cursor: 'pointer' }}>
            <span>Jetzt Kontakt aufnehmen</span>
          </div>
        </div>
      </section>

      <Footer activePage="ueber-uns" />

      <ContactModal isOpen={isContactModalOpen} onClose={closeContactModal} buttonSource={buttonSource} />
    </div>
  )
}

export default AboutUs
